/* global angular */
export default function NewsCarouselController(
  userService,
  authorizationService
) {
  const vm = this;
  vm.newsItems = [];
  vm.carouselSettings = {
    infinite: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '.news-carousel-previous',
    nextArrow: '.news-carousel-next',
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 810,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  _activate();

  function _activate() {
    if (authorizationService.getToken()) {
      userService.getCarouselItems().then((carouselItems) => {
        vm.newsItems = carouselItems;
        // Slick Carousel is outside Angular digest cycle, so we manually refresh
        angular.element('.news-carousel').slick('refresh');
      });
    }
  }
}

NewsCarouselController.$inject = [
  'userService',
  'authorizationService',
];
